import React, { useEffect, useState } from 'react';
import liracrypt from './Liracrypt/liracrypt';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import noImg from '../assets/static/noImg.jpeg';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
const ImageViewer = ({
    urlData,
    api,
    imgStyle
}) => {
    const [img, setImg] = useState();
    const [loading, setLoading] = useState(true);
    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    useEffect(() => {
        setLoading(true);
        liracrypt.get(api, { ...searchParams, ...urlData })
            .then(({ data }) => {
                if (data.isSuccess) {
                    setImg(data.data);
                } else {
                    setImg(noImg)
                };
                setLoading(false);
            })
            .catch(err => {
                console.log(err);
                setImg(noImg);
                setLoading(false);
            })
    }, []);


    return (
        <>
            {
                loading ?
                    <div style={{ display: 'flex', width: '100%', justifyContent: 'center', height: '100%', minHeight: 'inherit', alignItems: 'center' }}>
                        <Spin indicator={<LoadingOutlined spin style={{ fontSize: 50 }} />} />
                    </div> :
                    <div style={{ display: 'flex', justifyContent: 'center', padding: 8, ...imgStyle, width: '100%', height: 'auto' }}>
                        <img src={img} alt="Image" style={{ width: imgStyle?.width || "50%", height: imgStyle?.height || '50%' }} />
                    </div>
            }
        </>
    )
};

export default ImageViewer;